import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function Bonos() {
  const bonos = [{
    num: '01',
    title: 'MAPA RÁPIDO DE IA PARA EMPRENDEDORES ARGENTINOS',
    desc: 'Descubrí exactamente qué herramienta usar, para qué y en qué momento. Sin probar 10 apps al azar.',
    value: '$12.000 ARS'
  }, {
    num: '02',
    title: '100 PROMPTS RÁPIDOS PARA RESOLVER TAREAS DEL NEGOCIO',
    desc: 'Copiá, pegá y resolvé ventas, contenido, clientes y operaciones en minutos.',
    value: '$18.000 ARS'
  }, {
    num: '03',
    title: 'CHECKLIST DE IMPLEMENTACIÓN IA EN 7 DÍAS',
    desc: "Pasá de 'algún día lo hago' a tener tu primera implementación real en 7 días.",
    value: '$14.000 ARS'
  }, {
    num: '04',
    title: 'PLANTILLAS EXPRESS PARA WHATSAPP, INSTAGRAM Y VENTAS',
    desc: '58 plantillas listas para copiar, adaptar y enviar en menos de 2 minutos.',
    value: '$16.000 ARS'
  }, {
    num: '05',
    title: 'GUÍA ANTI-BLOQUEO PARA USAR IA SIN MIEDO',
    desc: 'Superá la confusión, el miedo y la parálisis para empezar con confianza desde hoy.',
    value: '$12.000 ARS'
  }, {
    num: '06',
    title: 'TRACKER DE RESULTADOS IA PARA EMPRENDEDORES',
    desc: 'Medí lo que mejorás, sostené el hábito y avanzá más rápido con datos reales.',
    value: '$12.000 ARS'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-brand-violet/5 border-y border-brand-violet/20" data-id="element-26">
      <div className="max-w-5xl mx-auto" data-id="element-27">
        <div className="text-center mb-16" data-id="element-28">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-gold/20 mb-6" data-id="element-29">
            <Gift className="w-8 h-8 text-brand-gold" data-id="element-30" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-31">
            🎁 LOS 6 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-xl text-gray-300" data-id="element-32">
            Siempre incluidos — Valor total: $84.000 ARS →{' '}
            <span className="text-brand-gold font-bold" data-id="element-33">
              GRATIS con tu Megapack
            </span>
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-34">
          {bonos.map((bono, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-dark border border-brand-gold/30 rounded-2xl p-6 relative overflow-hidden group hover:border-brand-gold/60 transition-colors" data-id="element-35">
              <div className="absolute top-0 right-0 w-24 h-24 bg-brand-gold/10 rounded-bl-full -z-10" data-id="element-36" />

              <div className="flex items-start gap-4" data-id="element-37">
                <div className="text-3xl font-bold text-brand-gold/50" data-id="element-38">
                  {bono.num}
                </div>
                <div data-id="element-39">
                  <h3 className="text-lg font-bold text-white mb-2 leading-tight" data-id="element-40">
                    🎁 BONO {parseInt(bono.num)}
                    <br data-id="element-41" />
                    {bono.title}
                  </h3>
                  <p className="text-gray-400 text-sm mb-4" data-id="element-42">{bono.desc}</p>
                  <div className="inline-flex items-center gap-2 text-sm" data-id="element-43">
                    <span className="text-gray-500 line-through" data-id="element-44">
                      Valor: {bono.value}
                    </span>
                    <span className="text-brand-gold font-bold" data-id="element-45">→ GRATIS</span>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center bg-brand-gold/10 border border-brand-gold/30 rounded-xl p-6" data-id="element-46">
          <p className="text-xl font-bold text-white" data-id="element-47">
            VALOR TOTAL BONOS:{' '}
            <span className="line-through text-gray-400" data-id="element-48">$84.000 ARS</span> →{' '}
            <span className="text-brand-gold" data-id="element-49">GRATIS con tu MegaPack</span>
          </p>
        </div>
      </div>
    </section>;
}